import React, { useEffect, useRef } from 'react';
import './Features.css';

const Features = () => {
  const featuresRef = useRef([]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.style.opacity = '1';
            entry.target.style.transform = 'translateY(0)';
          }
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -50px 0px' }
    );

    featuresRef.current.forEach((ref) => {
      if (ref) observer.observe(ref);
    });

    return () => observer.disconnect();
  }, []);

  const features = [
    {
      image: '/assets/scan-feature.png',
      title: 'Scan Physical Business Cards',
      description: 'Digitize them instantly with advanced OCR technology.'
    },
    {
      image: '/assets/leads-feature.png',
      title: 'Organize Expo Leads',
      description: 'Smart filtering, search, and categorization features.'
    },
    {
      image: '/assets/notes-feature.png.png',
      title: 'Track with Notes & Ratings',
      description: 'Add notes, photos, ratings, and schedule meetings.'
    },
    {
      image: '/assets/meetings-feature.png',
      title: 'Plan Meetings Fast',
      description: 'Schedule meetings directly from the app.'
    },
    {
      image: '/assets/export-feature.png',
      title: 'Export & Download',
      description: 'Export data in multiple formats anytime.'
    }
  ];

  return (
    <section className="features" id="features">
      <div className="container">
        <div className="section-header">
          <h2>Why Choose Scan2Card?</h2>
          <p>Save hours of manual data entry and keep all your expo leads organized</p>
        </div>

        <div className="features-grid">
          {features.map((feature, index) => (
            <div
              key={index}
              ref={(el) => (featuresRef.current[index] = el)}
              className="feature-card"
            >
              <div className="feature-phone">
                <img src={feature.image} alt={feature.title} />
              </div>
              <div className="feature-content">
                <h3>{feature.title}</h3>
                <p>{feature.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features;